module.exports = __webpack_public_path__ + "static/media/drukwidecyrBold.ef77bb52.otf";